// FLOW-13 (SPEC S2; PLAN G14, G16) — os segredos da conta no editor de flow e na ferramenta HTTP: a
// lista com busca da Autenticação, o autocompletar do `secret('` e o "Criar segredo" do erro do
// compilador. Um provedor só, que o `FlowEditor` injeta (`provide`): ele carrega o cofre uma vez por
// editor e recarrega quando um segredo é criado pelo "Novo segredo". Só nomes: o valor nunca volta
// (`flowSecretsApi`).
//
// O "Guardar como segredo" do Importar cURL continua no `segredosDoFlow.js`.
import { computed, ref } from 'vue';
import flowSecretsApi from 'dashboard/api/flowSecrets';

export const SEGREDOS_DA_CONTA = Symbol('segredosDaConta');

// `accountId()`: a conta de agora (como no `criarSegredosDoFlow`). `api`: o cliente, trocado nos
// testes.
export function criarSegredosDaConta({ accountId, api = flowSecretsApi }) {
  const segredos = ref([]);
  const carregado = ref(false);
  const erro = ref(null);
  let pedido = null;

  // Só a resposta do último pedido vale: um `recarregar` no meio de outro não volta à lista velha.
  // O pedido que falhou não fica guardado, e o próximo `carregar` tenta de novo.
  function buscar() {
    const este = Promise.resolve()
      .then(() => api.index(accountId()))
      .then(
        lista => {
          if (pedido !== este) return;
          segredos.value = Array.isArray(lista) ? lista : [];
          carregado.value = true;
          erro.value = null;
        },
        falha => {
          if (pedido !== este) return;
          erro.value = falha;
          pedido = null;
        }
      );
    pedido = este;
    return este;
  }

  return {
    // Os nomes em ordem, para a lista e o autocompletar.
    nomes: computed(() =>
      segredos.value
        .map(segredo => segredo?.name)
        .filter(Boolean)
        .sort((a, b) => a.localeCompare(b))
    ),
    carregado,
    erro,
    // Uma vez por editor: quem chama de novo recebe o mesmo pedido.
    carregar: () => pedido || buscar(),
    // Depois de criar um segredo (o "+ Novo segredo" da caixa, o "Criar segredo" do erro).
    recarregar: () => buscar(),
  };
}

// -- G16: o erro do compilador para o `secret()` que não está no cofre da conta. O texto é contrato
// (`powertools/contract/segredo_que_falta.json`, que o pytest confere no compilador e o vitest desta
// regex): "O segredo `crm_token` não existe nesta conta." O Rails diz a mesma frase numa linha só,
// com o `como_resolver` depois, e por isso a regex não ancora no fim.
export const SEGREDO_QUE_FALTA = /O segredo `([^`]+)` não existe nesta conta\./;

// O nome do segredo que falta, na `mensagem` de um problema do compilador (ou no texto dela), para o
// "Criar segredo" abrir o diálogo com ele; nulo em qualquer outro erro.
export function segredoQueFalta(problema) {
  const texto =
    typeof problema === 'string' ? problema : problema?.mensagem || '';
  const achado = SEGREDO_QUE_FALTA.exec(texto);
  return achado ? achado[1] : null;
}
